"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMatches = calculateMatches;
const aggregate_answers_match_score_1 = require("./aggregate-answers-match-score");
const calculate_match_score_percentage_1 = require("./calculate-match-score-percentage");
function calculateMatches(userAnswers, candidates, allCandidatesAnswers, useRandomTieBreaker = false) {
    const finalResults = [];
    const allCandidatesAnswersId = Object.keys(allCandidatesAnswers);
    for (const candidate of candidates) {
        if (allCandidatesAnswersId.includes(candidate.id)) {
            const candidateAnswers = allCandidatesAnswers[candidate.id];
            if (candidateAnswers) {
                const scoreObject = (0, aggregate_answers_match_score_1.aggregateAnswersMatchScore)(userAnswers, candidateAnswers);
                const match = (0, calculate_match_score_percentage_1.calculateMatchScorePercentage)(scoreObject);
                finalResults.push({
                    id: candidate.id,
                    match,
                });
            }
            // Also process nested candidates if they exist and have answers
            if (candidate.nestedCandidates && candidate.nestedCandidates.length > 0) {
                for (const member of candidate.nestedCandidates) {
                    if (allCandidatesAnswersId.includes(member.id)) {
                        const memberAnswers = allCandidatesAnswers[member.id];
                        if (memberAnswers) {
                            const scoreObject = (0, aggregate_answers_match_score_1.aggregateAnswersMatchScore)(userAnswers, memberAnswers);
                            const match = (0, calculate_match_score_percentage_1.calculateMatchScorePercentage)(scoreObject);
                            finalResults.push({
                                id: member.id,
                                match,
                            });
                        }
                    }
                }
            }
        }
        else if (candidate.nestedCandidates && candidate.nestedCandidates.length > 0) {
            const memberResults = [];
            for (const member of candidate.nestedCandidates) {
                const memberAnswers = allCandidatesAnswers[member.id] || [];
                const scoreObject = (0, aggregate_answers_match_score_1.aggregateAnswersMatchScore)(userAnswers, memberAnswers);
                const match = (0, calculate_match_score_percentage_1.calculateMatchScorePercentage)(scoreObject);
                memberResults.push({
                    id: member.id,
                    match,
                });
                finalResults.push({
                    id: member.id,
                    match,
                });
            }
            const combinedAnswers = candidate.nestedCandidates.flatMap((member) => allCandidatesAnswers[member.id] || []);
            const scoreObject = (0, aggregate_answers_match_score_1.aggregateAnswersMatchScore)(userAnswers, combinedAnswers);
            const match = (0, calculate_match_score_percentage_1.calculateMatchScorePercentage)(scoreObject);
            // Add the parent result without memberResults to match the test expectation
            finalResults.push({
                id: candidate.id,
                match,
            });
        }
    }
    return finalResults.sort((a, b) => {
        // Handle potentially undefined matches
        const bMatch = b.match ?? -1;
        const aMatch = a.match ?? -1;
        if (bMatch !== aMatch) {
            return bMatch - aMatch;
        }
        // Tie-breaker: random if enabled, otherwise deterministic by ID
        return useRandomTieBreaker ? Math.random() - 0.5 : a.id.localeCompare(b.id);
    });
}
